import { Map } from "immutable"

import {
    TOPIC_LIST_COUNT_REQUEST as LIST_REQUEST,
    TOPIC_LIST_COUNT_RESPONSE as LIST_RESPONSE,
    TOPIC_LIST_COUNT_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    TOPIC_LIST_COUNT_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"

import buildCountReducer from "./build-count-reducer"

const defaultSearchCriteria = Map({
    name: ""
})

export default buildCountReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)
